import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const DocumentRWPage = lazy(() =>
  import("../../../../../components/WMS/Transfers/RW/DocumentRWPage.tsx").then(
    (module) => ({ default: module.DocumentRWPage }),
  ),
)

type RWDocumentSearch = {
  tab: "general" | "info" | "files"
  edit?: 1
}

export const Route = createFileRoute("/_layout/WMS/documents/doc-rw/$docRw")({
  validateSearch: (search: Record<string, unknown>): RWDocumentSearch => {
    const tab =
      search.tab === "info"
        ? "info"
        : search.tab === "files"
          ? "files"
          : "general"
    return {
      tab,
      ...(search.edit === 1 || search.edit === "1" ? { edit: 1 } : {}),
    }
  },
  component: DocumentRWRoute,
})

function DocumentRWRoute() {
  return (
    <LazyRoutePage>
      <DocumentRWPage />
    </LazyRoutePage>
  )
}
